import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const ModalBody = styled.div`
  padding: ${spacing[6]};
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;

export const ModalTitle = styled.h2`
  margin: 0;
  ${typographyMixin("subtitle", 1)}
  color: ${rawColors.text.highEmphasis};
`;

export const ModalDescription = styled.p`
  margin: 0;
  ${typographyMixin("body", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;
